<h2 mat-dialog-title>{{popupTitle}}</h2>
<div class="popup-content">
    <!-- Links Section  -->
    <div class="top-panel">
        <div>Links</div>
    </div>

    <form [formGroup]="linkForm" class="show-mode">
        <span class="url-width">URL</span>
        <div class="link-value url-value-width">
            <input type="text" formControlName="linkValue">
        </div>
        <span class="url-label-width">URL Label</span>
        <div class="link-value url-value-width">
            <input type="text" formControlName="linkDescription">
        </div>
        <div class="action-buttons actions-width">
            <button (click)="addNewLink()" class="icon-button" [disabled]="linkForm.invalid">
                <mat-icon class="icon">add</mat-icon>
            </button>
        </div>
    </form>

    <div>
        <div *ngFor="let item of links | async; index as i">
            <calibration-set-link-attribute [link]="item" [index]="i" (delete)="deleteLink($event)">
            </calibration-set-link-attribute>
        </div>
    </div>

    <div class="top-panel">
        <div>Description (Public)</div>
    </div>

    <comment-attribute *ngIf="!calibrationSet && comment" [model]="comment" [fieldName]="'AttributeValue'"></comment-attribute>

    <comment-attribute *ngIf="calibrationSet" [model]="calibrationSet.currentState" [fieldName]="'Description'"></comment-attribute>

    <ziq-assumption-component [assumption]="assumption"></ziq-assumption-component>

    <ziq-zone-combination *ngIf="!!zoneCombination" [zoneCombination]="zoneCombination"></ziq-zone-combination>
</div>
<div class="popup-footer">
    <div class="attributes-button-container">
        <button class="button action" (click)="save()" [disabled]="disabled || !canSave">Save</button>
        <button mat-dialog-close class="button" (click)="onCancel()">Cancel</button>
    </div>
</div>
